var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgConnectivity28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5274 11.9394L19.1368 9.31542L20.4283 12.5684L13.2635 15.413L9.10969 21.3463L6.24248 19.339L9.82504 14.2216L6.14441 8.30294L9.11658 6.45465L12.5274 11.9394Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19653 8.93042C7.6626 8.93042 9.66174 6.93127 9.66174 4.46521C9.66174 1.99915 7.6626 0 5.19653 0C2.73047 0 0.731323 1.99915 0.731323 4.46521C0.731323 6.93127 2.73047 8.93042 5.19653 8.93042ZM5.19653 5.41913C5.72339 5.41913 6.15045 4.99207 6.15045 4.46521C6.15045 3.93835 5.72339 3.51129 5.19653 3.51129C4.66968 3.51129 4.24261 3.93835 4.24261 4.46521C4.24261 4.99207 4.66968 5.41913 5.19653 5.41913Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9517 13.9769C25.4177 13.9769 27.4169 11.9777 27.4169 9.51166C27.4169 7.04559 25.4177 5.04645 22.9517 5.04645C20.4856 5.04645 18.4865 7.04559 18.4865 9.51166C18.4865 11.9777 20.4856 13.9769 22.9517 13.9769ZM22.9517 10.4656C23.4785 10.4656 23.9056 10.0385 23.9056 9.51166C23.9056 8.98482 23.4785 8.55774 22.9517 8.55774C22.4248 8.55774 21.9977 8.98482 21.9977 9.51166C21.9977 10.0385 22.4248 10.4656 22.9517 10.4656Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2132 27.9999C7.67926 27.9999 9.67841 26.0008 9.67841 23.5347C9.67841 21.0687 7.67926 19.0695 5.2132 19.0695C2.74713 19.0695 0.747986 21.0687 0.747986 23.5347C0.747986 26.0008 2.74713 27.9999 5.2132 27.9999ZM5.2132 24.4886C5.74003 24.4886 6.16711 24.0616 6.16711 23.5347C6.16711 23.0079 5.74003 22.5808 5.2132 22.5808C4.68636 22.5808 4.25928 23.0079 4.25928 23.5347C4.25928 24.0616 4.68636 24.4886 5.2132 24.4886Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConnectivity28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;